export default "__VITE_ASSET__CLCPG3hS__"